<template>
  <div class="login">

    <Loader/>
    <div class="box">
      <div class="content">
        <b-form class="form-vertical login-form formV2" autocomplete="off">
          <div class="form-title">GOfix FM-Commercial</div>
          <div class="alert fade in alert-danger" style="display: none;"> <i class="icon-remove close" data-dismiss="alert"></i> Enter any username and password. </div>
          <gofix-form-input label="Email" v-on:keyup.enter="onEnterClick" autocomplete="email" v-model="$v.user.email.$model" ></gofix-form-input>
          <gofix-form-input label="Password" type="password" autocomplete="new-password" v-model="$v.user.password.$model" ></gofix-form-input>
          <div class="form-actions">
            <router-link class="c-orange forgotPass" :to="``">Forgot Password?</router-link>
            <b-button type="button" @click="login" variant="primary" :disabled="isAction" class="submit btn pull-right"> Login  <b-spinner v-if="isAction"  small></b-spinner>  </b-button>
          </div>
        </b-form>
      </div>
    </div>
  </div>
</template>
<script>
import { validationMixin } from 'vuelidate'
import { required, minLength,email } from 'vuelidate/lib/validators'
import Loader from './Loader.vue';
const AUTOFILLED = 'is-autofilled'
const onAutoFillStart = (el) => { if(el) el.classList.add('e-input-focus') }
const onAutoFillCancel = (el) => { if(el) el.classList.remove('e-input-focus') }
const onAnimationStart = ({ target, animationName }) => {
  switch (animationName) {
    case 'onAutoFillStart':
      return onAutoFillStart(target)
    case 'onAutoFillCancel':
      return onAutoFillCancel(target)
  }
}

export default {
  name: 'LogIn',
  components: {Loader},
  data () {
      return {
        user : {
          email : '',
          password : ''
        },
        isAction : false,
        type : 'password',
        isLoading: false,
      }
  },
  mixins: [validationMixin],
  validations: {
    user: {
      email: {
        required,
        email,
      },
      password : {
        required
      }
    }
  },
  computed: {

  },
  watch: {

  },
  async created() {
   
  },
  mounted: async function() {
    if(document.querySelector('.form-control')){
      document.querySelector('.form-control').addEventListener('animationstart', onAnimationStart, false);
    }
  },
  updated: async function() {
    await this.$nextTick();
    await this.setClassInput();
  },
  methods:{
    login(){
      this.$v.$touch()
      if (this.$v.$invalid) {
        return false;    
      }
      this.isLoading = true
      this.isAction = true;
      this.$store.dispatch( 'AuthController/login', {email : this.user.email.trim(), password : this.user.password.trim() } )
      .then(result =>{
        this.$router.push(`/v2/dashboard`);
        this.isAction = false;
        setTimeout(() => {
          this.isLoading = false
        },1000)
      })
      .catch(error=>{
        this.isAction = false;
        setTimeout(() => {
          this.isLoading = false
        },1000)
        this.$bvToast.toast('Login error!', {
          title: `Notification`,
          autoHideDelay: 3000,
          variant: 'danger',
          solid: true
        })
      })
    },
    showPassword(){
      if(this.type == 'password') 
        return this.type = 'text'
      return this.type = 'password'  
    },
    onEnterClick: function() {
      this.login();
    },
    async setClassInput() {
      if(!this.user.email) {
        onAutoFillCancel(document.getElementById('form-group-email'))
      }
      if(!this.user.password) {
        onAutoFillCancel(document.getElementById('form-group-password'))
      }
    }
  }
}
</script>
